var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasAccess && _vm.isActive)?_c('div',{staticClass:"login-dashboard-popup-link",domProps:{"textContent":_vm._s(_vm.data.name)},on:{"click":_vm.actionRedirect}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }